// extracted by mini-css-extract-plugin
export default {"filtersContainer":"GameFiltersForm_filtersContainer__ixiLE","toggleInput":"GameFiltersForm_toggleInput__jkUl0"};